import { api } from '@/api/axiosInstance';
import { ApiResponseType } from '../type/commonTypes';

export interface deleteFcmDeviceTokenProps {
  token: string;
}

export const deleteFcmDeviceToken = async (data: deleteFcmDeviceTokenProps) => {
  const res = await api.delete<ApiResponseType<null>>(
    '/api/notifications/device-tokens',
    { data }
  );
  return res.data;
};
